import {action, observable} from "mobx";
import appStore from "./appStore";
import poolService from "../services/poolService";
//import poolService from "../services/poolService.mock";

class poolStore {
    @observable poolList = [];

    @action getPoolList = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolList(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        this.poolList = resultOfRequest?.data?.data;
        return resultOfRequest.data;
    };

    @action getPool = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPool(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data.data;
    };

    @action getPoolSupporters = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolSupporters(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data.result;
    };

    @action getPoolSupportings = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolSupportings(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data.result;
    };

    @action createPool = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.createPool(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action updatePool = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.updatePool(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolAuthorizedUsers = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolAuthorizedUsers(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getUserPools = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getUserPools(params);
        await appStore.setLoading(false);
        return resultOfRequest.data;
    };

    @action setPoolAuthorizedUsers = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.setPoolAuthorizedUsers(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolPaymentContracts = async params => {
        const resultOfRequest = await poolService.getPoolPaymentContracts(params);
        return resultOfRequest;
    };

    @action createPoolPaymentContract = async params => {
        const resultOfRequest = await poolService.createPoolPaymentContract(params);
        return resultOfRequest;
    };

    @action getPoolH3Cells = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolH3Cells(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getPoolBySubCompanyId = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolBySubCompanyId(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createPoolMergeOptions = async params => {
        const resultOfRequest = await poolService.createPoolMergeOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action updatePoolMergeOptions = async params => {
        const resultOfRequest = await poolService.updatePoolMergeOptions(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action getPoolMergeOptions = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolMergeOptions(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }

        return resultOfRequest.data.data;
    };

    @action getPoolSubCompanies = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.getPoolSubCompanies(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action isSubcompanyDedicateIntegration = async params => {
        const resultOfRequest = await poolService.isSubcompanyDedicateIntegration(params);
        if (resultOfRequest.status !== 200) {
            return false;
        }
        console.log(resultOfRequest.data);
        return resultOfRequest.data?.success || false;
    };

    @action deletePoolMergeOptions = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.deletePoolMergeOptions(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action updateStatusPoolMergeOptions = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.updateStatusPoolMergeOptions(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action updateAllSubCompaniesMergeOptions = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.updateAllSubCompaniesMergeOptions(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return true;
    };

    @action deletePoolSupporter = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.deletePoolSupporter(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data.result;
    };

    @action updatePoolSupporter = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.updatePoolSupporter(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action updateSupporterActive = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.updateSupporterActive(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action createPoolSupporter = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.createPoolSupporter(params);
        await appStore.setLoading(false);
    };
    @action isPoolCustomerToShowMap = async params => {
        const resultOfRequest = await poolService.isPoolCustomerToShowMap(params);
        if (resultOfRequest.status !== 200) {
            return {
                isIntegrationTypeDedicated: false,
                companyIds: [],
                subCompanyIds: []
            };
        }
        return resultOfRequest.data;
    };
    @action getPoolIntensityCallbacks = async params => {
        const resultOfRequest = await poolService.getPoolIntensityCallbacks(params);
        if (resultOfRequest.status !== 200) {
            return false;
        }
        return resultOfRequest.data;
    };
    @action exportPoolExcelFile = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await poolService.exportPoolExcelFile(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
}

export default new poolStore();
